import { render, staticRenderFns } from "./CCBill.vue?vue&type=template&id=3963667e&"
import script from "./CCBill.vue?vue&type=script&lang=ts&"
export * from "./CCBill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports